import store from '@/plugins/vuex'

const routes = [
  {
    path: '/label/home',
    name: 'Label Dashboard',
    title: 'Dashboard',
    beforeEnter(to, from, next) {
      store.commit('artistDashboard/setSelectedTrack', null)
      store.commit('artistDashboard/setSelectedArtist', null)
      next()
    },
    component: () =>
      import(/* webpackChunkName: 'dashboard-label' */ './views/Index.vue')
  }
]

export default routes
